import { defineMessages } from 'react-intl';

export const selectDimensionMessages = defineMessages({
  SelectVariation: {
    id: 'product.variationSelect.select.selectVariation',
    defaultMessage: 'Bitte wählen',
  },
});
